import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, MobileMenuButton } from './Sidebar';
import DamageAlertModal, { useDamageAlerts } from '../damage/DamageAlertModal';

export const MainLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { alerts, showModal, setShowModal, handleAcknowledge } = useDamageAlerts();

    return (
        <div className="app-container">
            <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
            
            <main className="main-content">
                {/* Header with mobile menu */}
                <div className="content-header flex items-center gap-4">
                    <MobileMenuButton onClick={() => setSidebarOpen(true)} />
                    <div className="flex-1" />
                </div>
                
                <div className="content-body">
                    <Outlet />
                </div>
            </main>
            
            
            {/* Damage Alert Modal - shows automatically when damage is detected */}
            <DamageAlertModal
                isOpen={showModal && alerts.length > 0}
                onClose={() => setShowModal(false)}
                alerts={alerts}
                onAcknowledge={handleAcknowledge}
            />
        </div>
    );
};
